import 'babel-polyfill'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import Modal from '../../components/modal'
import loading from '../../components/loading'
import toolTip from '../../components/toolTip'
import message from '../../components/message'
import { initSentry } from '../../utils/Sentry'
import '../../../../svg_sprites/icons/modal_icons'

initSentry()
Vue.prototype.$ajax = axios
Vue.prototype.PageInfo = PageInfo
Vue.prototype.getConstants = props => Constants[props] || ''
Vue.use(loading)
Vue.use(Modal)
Vue.use(message)
Vue.component('tool-tip', toolTip)

void new Vue({
	el: '#app',
	render: h => h(App),
})
